import React, { createContext, useContext, useState, useCallback } from "react";

const TrainingContext = createContext(null);

export function TrainingProvider({ children }) {
  const [trainings, setTrainings] = useState([]);

  const addTraining = useCallback((tr) => {
    setTrainings((prev) => [tr, ...prev]);
  }, []);

  const updateTraining = useCallback((id, updates) => {
    setTrainings((prev) =>
      prev.map((t) => (t.id === id ? { ...t, ...updates } : t))
    );
  }, []);

  const removeTraining = useCallback((id) => {
    setTrainings((prev) => prev.filter((t) => t.id !== id));
  }, []);

  const value = { trainings, addTraining, updateTraining, removeTraining };
  return (
    <TrainingContext.Provider value={value}>
      {children}
    </TrainingContext.Provider>
  );
}

export function useTraining() {
  const ctx = useContext(TrainingContext);
  if (!ctx) throw new Error("useTraining must be used within TrainingProvider");
  return ctx;
}

export default TrainingContext;
